module.exports = __webpack_public_path__ + "img/type--3-spans--multiple-lang--de.450d8b78.jpg";